import React from 'react'
import { useWindowResizeSensor } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import ContentViewport from 'src/components/Settings/ContentViewport'
import ProtoColumnB from 'src/components/Settings/ProtoColumnB'
import ProtoColumnC from 'src/components/Settings/ProtoColumnC'
import NotFound from 'src/pages/NotFound'
import PeopleHome from './Home'
import PeoplePrivacy from './Privacy'
import PeopleRole from './Role'

const SettingsPeople = () => {
   const match = useRouteMatch()
   const { currentBreakpoint } = useWindowResizeSensor()
   const currentModeHasThreeColumns = currentBreakpoint > 'd'

   return (
      <ContentViewport>
         <ProtoColumnB>
            <PeopleHome />
         </ProtoColumnB>
         <Switch>
            {currentModeHasThreeColumns && (
               <Redirect
                  exact
                  from={match.url}
                  to={`${match.url}/privacy`}
               />
            )}
            <Route
               path={`${match.url}/:section`}
               render={() => (
                  <ProtoColumnC>
                     <Route
                        path={`${match.path}/privacy`}
                        component={PeoplePrivacy}
                     />
                     <Route
                        component={PeopleRole}
                        path={[
                           `${match.url}/role/:roleId/:roleStatus(declined|invited|inactive)`,
                           `${match.url}/role/:roleId`
                        ]}
                     />
                  </ProtoColumnC>
               )}
            />
            <Route
               path={`${match.url}/:invalid`}
               component={NotFound}
            />
         </Switch>
      </ContentViewport>
   )
}

export default SettingsPeople
